import { MatPaginatorIntl } from "@angular/material/paginator"

export function customPaginator() {
  const paginator = new MatPaginatorIntl()
  paginator.itemsPerPageLabel = "Aantal resultaten per pagina"
  paginator.nextPageLabel = "Volgende pagina"
  paginator.previousPageLabel = "Vorige pagina"
  return paginator
}